import {atom} from "jotai";

export const SurveyAtom = atom(null);
export const AnswersAtom = atom([]);
export const AnswerAtom = atom(null);
export const SurveyQuestionsAtom = atom([]);
export const PrefetchedImagesAtom = atom({});
